import getConfig from "next/config";

/**
 * La tipografía y los colores del design system aplican sólo a InfoCasas (UY/PY/PE/BO) y a
 * Casas y Más, que es un clon de InfoCasas con su propia marca (laudo de pablo, 2026-10-21).
 * No alcanza con country_code porque Casas en el Este también es UY: lo que las separa
 * es el tema.
 *
 * Se lee en cada llamada y no a nivel de módulo: si getConfig() todavía no estuviera
 * listo al importar, la clase quedaría apagada para siempre y sin aviso.
 */
export const isInfoCasasTheme = () =>
	["infocasas", "casasymas"].includes(getConfig()?.publicRuntimeConfig?.APP_THEME);
